// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__15RF_","rootSmall":"AddTileButton_rootSmall__1aNWl"};